module.exports = __webpack_public_path__ + "static/img/mould4.e03a0a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/indexEditor/mould/mould4.png
// module id = Ld5x
// module chunks = 3